/**
 * Identity coercion for the PWA session user.
 *
 * Mirrors mobile `UserModel.fromJson` (apps/mobile/lib/features/auth/models/user_model.dart):
 * the backend serialises enums (`role`, `kycStatus`) as integers, so we coerce
 * them with `String(value)` semantics and fall back to safe defaults when the
 * payload omits the fields (legacy payloads keep working).
 */
export interface UserIdentity {
  role: string
  accountType: string
  kycStatus: string
}

export const DEFAULT_IDENTITY: UserIdentity = {
  role: '',
  accountType: 'client',
  kycStatus: '',
}

export function parseUserIdentity(
  raw: Record<string, unknown> | null | undefined,
): UserIdentity {
  if (raw == null) return { ...DEFAULT_IDENTITY }
  return {
    role: raw.role == null ? '' : String(raw.role),
    accountType:
      raw.accountType == null ? 'client' : String(raw.accountType),
    kycStatus: raw.kycStatus == null ? '' : String(raw.kycStatus),
  }
}
